import '../styles/PageGlobal.css';
import './ClientListPage.css';
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ReferenceButton from '../components/ReferenceButton';
import { ClientService } from '../services/ClientService.js';

export default function ClientListPage() {
  const { client_list_id, client_id } = useParams();
  const navigate = useNavigate();

  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchClients = useCallback(async () => {
    setLoading(true);
    try {
      const clientService = new ClientService();
      const data = await clientService.getAllClients();
      setClients(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchClients(); }, [fetchClients]);

  const handleEdit = (id) => navigate(`/client_edit/${id}`);

  if (loading) return <div>Chargement…</div>;
  if (error) return <div>Erreur: {error}</div>;

  return (
    <div className="containerMain client-container">
      <h1 className="client-title">Liste des Clients</h1>
      <p className="client-subtitle">Ceci est un contenu protégé</p>
      <p className="client-debug">DEBUG client_list_id: {client_list_id}</p>

      <div className="client-table-wrapper">
        <table className="client-table">
          <thead>
            <tr>
              <th>N°</th><th>Société 1</th><th>Société 2</th>
              <th>Adresse 1</th><th>Adresse 2</th><th>Code postal</th>
              <th>Téléphone</th><th>Ville</th><th>Pays</th>
              <th>KBIS</th><th>SIRET</th><th>SIREN</th>
              <th>TVAIntraCommunity</th><th>Action</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c) => {
              // Extract the primary address from the backend List<AddressDTO>
              const addr = c.addresses && c.addresses.length > 0 ? c.addresses[0] : {};
              return (
                <tr key={c.id}>
                  <td>{c.id}</td>
                  <td>{c.societe1}</td>
                  <td>{c.societe2}</td>
                  <td>{addr.adresse1 || ''}</td>
                  <td>{addr.adresse2 || ''}</td>
                  <td>{addr.codePostal || ''}</td>
                  <td>{c.telephone}</td>
                  <td>{addr.ville || ''}</td>
                  <td>{addr.pays || ''}</td>
                  <td>{c.kbis}</td>
                  <td>{c.siret}</td>
                  <td>{c.siren}</td>
                  <td>{c.tvaIntraComm || ''}</td> {/* Backend only has tvaIntraComm */}
                  <td className="client-action-cell">
                    <button className="client-btn client-btn-blue" onClick={() => handleEdit(c.id)}>Edit</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="client-bottom-actions">
        <ReferenceButton to="/client_new">+ Créer un client</ReferenceButton>
        {client_id && (
          <ReferenceButton to={`/client_edit/${client_id}`}>Client Details / Edit</ReferenceButton>
        )}
      </div>
    </div>
  );
}